<template>
  <section class="barocare-conci-inquiry" id="barocare-conci-inquiry">
    <div class="faq faq-container">
      <div class="title-area" v-intersect>
        <h2 class="text-xl">자주 묻는 질문</h2>
      </div>
      <dl class="faq-list" v-intersect>
        <dt :class="{ 'opened': openIndex === 0 }">
          <button type="button" @click="toggle(0)">
            <span class="subject">인슐린도 처방이 가능한가요?</span>
          </button>
        </dt>
        <dd v-show="openIndex === 0">
          <ul>
            <li>
              기존에 처방받으신 약품 이름과,  AGP보고서 등을 토대로 의사 진료 후 처방이 가능합니다. 발급된 전자처방전을 약국으로 보내면 약품 수령이 가능합니다.
            </li>
            
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 1 }">
          <button type="button" @click="toggle(1)">
            <span class="subject">기존에 다니던 병원을 이용할 수 있나요? </span>
          </button>
        </dt>
        <dd v-show="openIndex === 1">
          <ul>
            <li>
             솔닥 컨시어지 서비스는 솔닥과 제휴된 병원만 이용이 가능합니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 2 }">
          <button type="button" @click="toggle(2)">
            <span class="subject">처방전을 다른 곳에서 발행받았는데, 소모성재료 구매를 할 수 있나요?</span>
          </button>
        </dt>
        <dd v-show="openIndex === 2">
          <ul>
            <li>
                환자 등록 및 위임 청구 과정을 진행해주시면, 솔닥 컨시어지를 통해 물품을 구매하고 솔닥이 제공하는 각종 혜택을 받을 수 있습니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 3 }">
          <button type="button" @click="toggle(3)">
            <span class="subject"
              >미성년자도 비대면 진료를 받을 수 있나요?</span
            >
          </button>
        </dt>
        <dd v-show="openIndex === 3">
          <ul>
            <li>
              나이 제한 없이 비대면 진료를 이용할 수 있습니다. 보호자분께서 환자를 보조하여 의사와 대화하는 것도 가능하지만, 진료 중에는 환자가 반드시 함께 있어야 합니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 4 }">
          <button type="button" @click="toggle(4)">
            <span class="subject"
              >홈페이지 물품 목록에 있는 항목만 구매가 가능한가요?</span
            >
          </button> 
        </dt>
        <dd v-show="openIndex === 4">
          <ul>
            <li>
              홈페이지 목록에서 보이지 않는 소모성재료는 솔닥 컨시어지 고객센터로 문의해주세요. 빠르게 주문 가능 여부를 확인한 후 답변해드리겠습니다.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
    <div class="visual-area">
        <div class="img-area">            
        </div>
        <div class="text-area" v-intersect>
            <strong class="text-header">직접 써보는 게<br>가장 빨라요 </strong>
            <p class="text-cont">당뇨인을 위한 세상에 없던 서비스, <br>
            지금 바로 경험해 보세요</p>
            <div class="btn-wrap">
                <a class="cta_008" href="https://solcon.channel.io/home" target="_blank" title="새창"><i class="ico-chat"></i>간편 채팅 상담</a>
                <a href="/barocarenew/sub1">취급 품목 확인하기</a>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BarocareConciInquiry',
  data() {
    return {
      openIndex: 0 // 초기에 아무 항목도 열려있지 않음
    };
  },
  methods: {
    toggle(index) {
      // 이미 열려 있는 항목을 클릭하면 모두 닫힘
      this.openIndex = this.openIndex === index ? -1 : index;
    }
  },
  directives: {
      intersect: {
          // 요소가 DOM에 삽입될 때 호출됩니다.
          inserted(el) {
              const options = {
                  root: null, // 뷰포트를 기본값으로 설정
                  rootMargin: '0px', // 뷰포트의 마진은 0
                  threshold: 0.1 // 10%가 보일 때 콜백이 실행
              };
              const callback = (entries, observer) => {
                  entries.forEach(entry => {
                      if (entry.isIntersecting) {
                          el.classList.add('visible');
                      } else {
                          el.classList.remove('visible');
                      }
                  });
              };
              const observer = new IntersectionObserver(callback, options);
              observer.observe(el); // 해당 요소를 관찰 시작
          }
      }
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_conci/BarocareConciInquiry.vue